module.exports = __webpack_public_path__ + "static/media/8.4007438d.jpg";